var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJsFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179087",
    transform: "translate(-82 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(82 164)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29981",
    d: "m8.114 5.333 2.28 2.273.387.394h8.554v10.668h-16V5.333h4.78M8.114 4H3.333A1.333 1.333 0 0 0 2 5.333v13.335A1.333 1.333 0 0 0 3.333 20h16a1.333 1.333 0 0 0 1.333-1.333V8a1.333 1.333 0 0 0-1.333-1.333h-8L9.06 4.393A1.333 1.333 0 0 0 8.114 4z",
    transform: "translate(86.666 167.999)",
    style: {
      fill: "#231f20"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsFolderIcon);
export default __webpack_public_path__ + "static/media/js-folder-icon.774fef6f3529ad43bf2f87f836709fd7.svg";
export { ForwardRef as ReactComponent };